.navUpload {
  position: absolute;
  margin: 0 auto;
  left: 0;
  right: 0;
  text-align: center;
}
